module.exports = __webpack_public_path__ + "static/RootSans-13Ultra-8b933b78c3635cc18e9cb9119c00ed0f.woff2";